import { render, staticRenderFns } from "./logManagement.vue?vue&type=template&id=618c795c&scoped=true&"
import script from "./logManagement.vue?vue&type=script&lang=js&"
export * from "./logManagement.vue?vue&type=script&lang=js&"
import style0 from "./logManagement.vue?vue&type=style&index=0&id=618c795c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618c795c",
  null
  
)

export default component.exports